<template>
  <div>
    <v-card>
      <v-toolbar color="primary" dark class="mb-4 v-toolbar-header">
        <v-toolbar-title aling="center">Zonas de inventario</v-toolbar-title>
        <v-spacer></v-spacer>

      </v-toolbar>
      <v-card flat>
        <PlusMenu :default-action="viewDialog"/>
        
        <v-card-text>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line hide-details
            class="mb-4"></v-text-field>
          <v-data-table :headers="headers" :items="zones" :search="search" class="elevation-1 custom-font">
            <template v-slot:[`item.active`]="{ item }">
              <v-chip :color="item.active ? 'success' : 'error'" dark>
                {{ item.active ? "Activo" : "Inactivo" }}
              </v-chip>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <v-icon small class="mr-2" @click="viewItem(item)">mdi-pencil</v-icon>
              <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
            </template>
            <template v-slot:no-data>
              No hay items
            </template>
          </v-data-table>
        </v-card-text>

      </v-card>
    </v-card>

    <v-dialog v-model="viewZone" max-width="1000px" :key="keyView" >
      <zones :zoneData="zoneData" v-on="{ closeModal }"/>
    </v-dialog>
  </div>

</template>
<script>
import UserProfile from "../../data";
import PlusMenu from "../../components/plusMenu.vue"
import zones from "./zones.vue";
import clientHttp from "../../tools/clientHttp";
import { getInventoryZones, loadInventoryZones, deleteInventoryZone } from '../../dataApi'
export default {
  components: {
    PlusMenu,
    zones
  },
  data: () => ({
    user: UserProfile.getUserData(),
    search: "",
    viewZone: false,
    zones:[],
    headers: [
      { text: "Id", value: "id" },
      { text: "Nombre", value: "name" },
      { text: "Descripcion", value: "description" },
      { text: "Estado", value: "active" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    editedIndex: -1,
    zoneData: {
      name: '',
      description: '',
      id: null
    },
    keyView: 0,
  }),

  created() {
    this.initialize();
  },

  methods: {

    viewDialog() {
      this.zoneData = {
        name: '',
        description: '',
        id: null
      }
      this.viewZone = true;
    },

    async initialize() {
      this.zones = await loadInventoryZones();
    },

    viewItem(item) {
      this.zoneData = item;
      console.log("🚀 ~ file: list.vue:92 ~ viewItem ~ item:", item)
      this.keyView++;
      this.viewZone = true;
    },

    editItem(item) {
      this.kitId = item.id;
      this.keyStock++;
      this.viewZone = true;
    },

    closeModal(action = null, data = null){
      console.log("🚀 ~ file: list.vue:105 ~ closeModal ~ action:", action, data)
      this.viewZone = false;
      if(action){
        if(action === 'create'){
          this.zones.push(data);
        }else if(action === 'update'){
          this.zones = this.zones.map(zone => zone.id === data.id ? data : zone);
        }
      }
      this.zoneData = {
        name: '',
        description: '',
        id: null
      }
      this.keyView++;
    },

    async deleteItem(item){
            swal({text: "Se eliminará el registro, ¿Desea continuar?", icon: "info", buttons: ["Cancelar", "Continuar"],})
            .then(async() => {
                await deleteInventoryZone(item.id);
                this.zones = this.zones.filter(zone => zone.id !== item.id)
            })
    },

  },
};
</script>

<style lang="scss">
.topbar-logo {
  max-width: 150px;
}
.combo-parametros {
  .v-select__selections {
    min-height: 56px !important;
  }
}
.theme--dark.v-chip.default {
  background: #f1f1f1;
  color: rgba(0, 0, 0, 0.87);
}
.v-text-field__details {
  display: none;
}

.custom-font {
  font-family: 'Your Font Family', sans-serif;
  font-size: 16px; /* ajusta el tamaño de la fuente según tus necesidades */
  text-transform: uppercase;
}
.header {
  font-family: Arial, sans-serif;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  background-color: #f0f0f0;
  border-bottom: 1px solid #ccc;
}

.column {
  flex: 1;
}

.logo {
  text-align: left;
}

.title {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.date-time {
  text-align: right;
}
</style>
